import useAppStore from '@/store/app';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { Outlet, useRouteLoaderData } from 'react-router-dom';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';

export default function AppsLayout() {
  const { apps, deployments } = useRouteLoaderData('auth');
  const [publicApps, setPublicApps] = useState([]);
  const { setNavigation } = useAppStore();

  useEffect(() => {
    const publicApps = apps.filter((app) => app?.public);

    deployments.forEach((deployment) => {
      const app = apps.find((a) => a._id === deployment.app);
      if (app?.public) {
        const publicApp = publicApps.find((a) => a._id === app._id);
        publicApp.deployed = true;
      } else {
        publicApps.push({ ...app, deployed: true });
      }
    });
    const uniqueApps = Array.from(
      new Map(publicApps.map((app) => [app._id, app])).values(),
    ).sort((a, b) => {
      if (a.deployed === b.deployed) {
        return (a.title || '').localeCompare(b.title || '', undefined, {
          sensitivity: 'base',
        });
      }
      if (a.deployed) return 1;
      return -1;
    });

    const appsWithoutFrontend = uniqueApps.filter(
      (app) => app.title !== 'Codemeta Dev' && app.title !== 'Codemeta',
    );

    setPublicApps(appsWithoutFrontend);
  }, [apps]);

  useEffect(() => {
    setNavigation({
      base: '/apps',
      items: [
        ...publicApps.map((d) => ({
          title: d?.title || 'Untitled',
          slug:
            d?.name || d?.title?.toLowerCase().replace(/\s+/g, '') || d?._id,
          hasEndIcon: d.deployed,
          endIcon: CloudDoneOutlinedIcon,
        })),
      ],
    });
  }, [publicApps]);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          position: 'relative',
          maxWidth: '100%',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
